import Api from '@/services/Api'

export default {
  get (id) {
    return Api().get('apps/' + id + '/users')
  },
  getUser (appId, id) {
    return Api().get('apps/' + appId + '/users/' + id)
  },

  add(appId, payload) {
    return Api().post('apps/' + appId + '/users', payload)
  },
  
  update(appId, userId, payload) {
    return Api().put('apps/' + appId + '/users/' + userId, payload)
  },

  delete(appId, userId) {
    return Api().delete('apps/' + appId + '/users/' + userId)
  }


}